<template>
  <div class="wl-your-prices mt-3" v-if="template">
    <draggable v-model="template" handle=".group-handle" @end="update_order">
      <div class="wl-group" v-for="(group, index) in template" :key="index">
        <div class="row">
          <div class="col">
            <h5
              class="wl-group-header"
              :class="{ 'group-handle': editable }"
              v-if="group.name"
            >
              <svg
                class="bi"
                fill="currentColor"
                width="17px"
                height="17px"
                v-if="editable"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                />
              </svg>
              {{ group.name }}
            </h5>
          </div>
        </div>
        <div class="w-100">
          <table class="table">
            <thead>
              <tr>
                <th v-if="editable"></th>
                <th>Description</th>
                <th>Case Size</th>
                <th>List Price</th>
                <th>Invoice Price</th>
                <th v-if="isStaff && !presentationMode && editable">
                  SAP Cost
                </th>
                <th v-if="isStaff && !presentationMode && editable">Margin</th>
                <th v-if="editable"></th>
              </tr>
            </thead>
            <draggable
              v-model="group.items"
              tag="tbody"
              handle=".handle"
              @end="update_order"
            >
              <tr
                class="wl-data-table-row"
                v-for="item in group.items"
                :key="item.product._id"
                :class="{ 'opacity-1': item.hide }"
              >
                <td class="handle" v-if="editable">
                  <svg
                    class="bi"
                    fill="currentColor"
                    width="17px"
                    height="17px"
                  >
                    <use
                      xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                    />
                  </svg>
                </td>
                <td>
                  <a :href="item.product._source.Permalink" target="_blank">{{
                    item.product._source.ItemDescription[0]
                  }}</a
                  ><br />
                  <small>LWIN: {{ item.item_code.substr(0, 7) }}</small>
                </td>
                <td>{{ item.product._source.CaseSize }}</td>
                <td>
                  {{ item.list_price | currency }}
                </td>
                <td class="wl-price-input-col" v-if="isStaff && editable">
                  <b-input-group size="sm" prepend="£">
                    <b-form-input
                      type="tel"
                      size="sm"
                      no-wheel
                      v-model.number.lazy="item.actual_price"
                      debounce="500"
                      @input="make_dirty"
                      @change="update_actual_price(item.item_code, $event)"
                    ></b-form-input>
                  </b-input-group>
                </td>
                <td v-else>
                  {{ item.actual_price | currency }}
                </td>
                <td v-if="isStaff && !presentationMode && editable">
                  {{ item.cost_price | currency }}
                </td>
                <td v-if="isStaff && !presentationMode && editable">
                  {{ margin(item) | percentage }}
                </td>
                <td v-if="editable">
                  <div class="wl-brochure-actions text-center">
                    <b-link
                      class="mb-1"
                      @click="
                        item.hide = !item.hide;
                        hide_item(item.item_code, item.hide);
                      "
                    >
                      <svg
                        class="bi"
                        fill="currentColor"
                        width="17px"
                        height="17px"
                      >
                        <use
                          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#eye-slash"
                        />
                      </svg> </b-link
                    ><br />
                    <b-link
                      @click="
                        $emit('remove-item', { item_code: item.item_code })
                      "
                      ><svg
                        class="bi"
                        fill="currentColor"
                        width="17px"
                        height="17px"
                      >
                        <use
                          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x-square"
                        />
                      </svg>
                    </b-link>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array,
    },
    slug: {
      type: String,
    },
    presentationMode: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    margin: () => (item) => {
      return ((item.actual_price - item.cost_price) / item.actual_price) * 100;
    },
  },
  mounted() {
    this.data_incoming = true;
    this.template = JSON.parse(JSON.stringify(this.value));
  },
  methods: {
    make_dirty() {
      this.dirty = true;
    },
    update_actual_price(item_code, actual_price) {
      this.$emit("update-item", {
        item_code,
        custom_price: actual_price,
      });
      this.dirty = false;
    },
    hide_item(item_code, hide) {
      this.$emit("hide-item", {
        template: "PRICE",
        data: {
          item_code,
          hide,
        },
      });
    },
    update_order() {
      this.$emit("update-order", {
        template: "PRICE",
        data: {
          groups: this.template,
        },
      });
    },
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        if (!this.dirty) {
          this.template = JSON.parse(JSON.stringify(val));
        }
      },
    },
    template: {
      deep: true,
      handler(val) {
        if (this.data_incoming) {
          this.data_incoming = false;
          return;
        }

        this.$emit("change", val);
      },
    },
  },
  data() {
    return {
      template: false,
      data_incoming: false,
      dirty: false,
    };
  },
};
</script>